import { useQuery } from "@tanstack/react-query";
import { meetingManager } from "../api/meetings";

export const useFetchMeetings = ({ projectId, page, limit, filterType }: { projectId: string | null; page: number; limit: number; filterType: 'upcoming' | 'completed' | 'overdue' }) => {

    const { data, isLoading, isError, error, refetch } = useQuery({
        queryKey: ["meetings", projectId, page, limit, filterType],
        queryFn: () => meetingManager.getMeetings({ page, limit, filterType }),
    });

    return {
        meetingData: data?.data?.rows || [],
        pagination: data?.data?.pagination,
        isLoading,
        isError,
        error,
        refetch
    };

};